import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DashboardHeader from '../../../shared/components/DashboardHeader';
import AttendancePanel from '../../GradesPerSubject/components/AttendancePanel';
import { getSecretarySubject, secretaryAttendanceService } from '../services/classSecretaryService';

function ClassSecretaryAttendancePage() {
  const { subjectId } = useParams();
  const [subject, setSubject] = useState(null);
  const [roster, setRoster] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getSecretarySubject(subjectId)
      .then((result) => {
        if (!mounted) return;
        if (!result) {
          setError('Subject not found, or not taught to your section.');
          setSubject(null);
        } else {
          setSubject(result.subject);
          setRoster(result.roster);
        }
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load subject');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [subjectId]);

  return (
    <div className="h-dvh w-full flex flex-col bg-appbg overflow-hidden">
      <DashboardHeader title={subject?.name ?? 'Attendance'} backTo="/student-dashboard/secretary" />

      <div className="flex-1 min-h-0 flex flex-col p-4 w-full lg:w-4/5 lg:mx-auto">
        {loading ? (
          <p className="w-full text-center text-gray-500 py-12">Loading…</p>
        ) : error ? (
          <p className="w-full text-center text-red-600 py-12">{error}</p>
        ) : (
          <AttendancePanel
            subject={subject}
            sections={[]}
            roster={roster}
            rosterLoading={false}
            attendanceService={secretaryAttendanceService}
          />
        )}
      </div>
    </div>
  );
}

export default ClassSecretaryAttendancePage;
